export const MainConfig = {
    AppDetails: {
        app_name: "Mashmalo", 
        app_description: "Mashmalo Parcel Delivery App",
        app_identifier: "com.saxum.mashmalo",
        ios_app_version: "1.0.0",
        android_app_version: 100
    },
    FirebaseConfig: {
        apiKey: "AIzaSyAng6K703jIZ6SiVYRT-xyr7jMZhq7YXNY",
    authDomain: "mashmalo.firebaseapp.com",
    databaseURL: "https://mashmalo-default-rtdb.firebaseio.com",
    projectId: "mashmalo",
    storageBucket: "mashmalo.appspot.com",
    messagingSenderId: "603493689886",
    appId: "1:603493689886:web:2545d13657b72cc0df9c0f",
    measurementId: "G-ZKZ91C14QN"
    },
    Google_Map_API_Key: {
        ios: "AIzaSyDGom5X_L6fTcanWEAJKOmn8Ky9hLxmqnU",
        android: "AIzaSyDLwKL4KpTP6IleFTvohpjz9J1kCJWKf9A",
        web: "AIzaSyAw2s9at71n3VsBv9RoB5J__Z569W7MO2U"
    },
    facebookAppId: "1083250402413199",
    PurchaseDetails: {
        CodeCanyon_Purchase_Code: "3eac8d43-ba43-4632-a0ee-88c3506bfb79",
        Buyer_Email_Address: "cephaskeys@gmail.com"
    }
}